module.exports = __webpack_public_path__ + "img/botan 18 - jjtri tee.fd0fc99e.png";